<!--
 * @Description:子表单
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="drag-sub-form-item-title" :style="{ maxWidth: 'calc(100% - 20px)', marginRight: '4px' }">
    <qfei-icon-more-two-outlined class="mover drag-mover" :class="{ 'mover-icon-disabled': isSysLayout }" />
    <component class="filed-icon" :is="QfeiIconSubFormOutlined" />
    <xl-label-text cursor="pointer" :value="props?.element?.label" :row="1" />
    <jw-tooltip v-if="props?.element?.toast">
      <qfei-icon-question-mark-outlined size="14" />
      <!-- 这是提示文本  -->
      <template #content> {{ props?.element.toast }} </template>
    </jw-tooltip>
    <qf-icon-required v-if="props?.element?.isRequired" />
  </div>
  <div class="detail-drag-item-content drag-sub-item-content scrollbar-style-config">
    <div class="drag-sub-item-content-35" v-if="props?.element?.modules?.length">
      <draggable :disabled="isSysLayout" :group="{ name: 'itxst111', sort: true, put: false, pull: false }" animation="500" :list="props?.element.modules" class="drag-sub-item-content-ele" :key="subIndex" ghostClass="ghost-sub-class" itemKey="index">
        <template #item="{ element: subElement, index: subIndex }">
          <div :class="['drag-item-list', data.active == 'details' && data.editFieldObj?.value == subElement?.value && subElement?.value ? 'item-sub-click' : 'not-item-sub-click', isSysLayout ? 'drag-item-list-unover' : '']" @click.stop.prevent="setConfig(subElement)" :key="subIndex">
            <span class="drag-item-label">
              <qf-icon-required v-if="subElement?.isRequired" />
              <span class="drag-mover-placeholder"></span>
              <qfei-icon-more-two-outlined class="mover drag-mover" :class="{ 'mover-icon-disabled': isSysLayout }" />
              <span>{{ subElement?.label }}</span>
              <template v-if="subElement?.toast">
                <jw-tooltip>
                  <qfei-icon-question-mark-outlined size="14" />
                  <!-- 这是提示文本  -->
                  <template #content>
                    {{ subElement.toast }}
                  </template>
                </jw-tooltip>
              </template></span
            >

            <div class="item-input-content" @click.stop.prevent="setConfig(subElement)">
              <span class="item-seat"></span>
            </div>

            <!--附加说明 -->
            <p class="sub-tips" v-if="subElement?.memo" :title="subElement?.memo">
              {{ subElement?.memo }}
            </p>
          </div>
        </template>
      </draggable>
    </div>
    <div class="empty-content" v-else>
      <jw-empty :description="$t('请添加字段')" />
    </div>
  </div>
</template>

<script setup>
import draggable from 'vuedraggable';
import { reactive, inject, computed } from 'vue';
import { QfeiIconMoreTwoOutlined, QfeiIconQuestionMarkOutlined, QfeiIconSubFormOutlined } from '@qfei-design/icons-vue';
import { useEntityGrayStore } from '@/store';
const entityStore = useEntityGrayStore(); // 对象灰度

const getParentMetheds = inject('publicMethods');
const sendModule = getParentMetheds?.sendModule || (() => {}); //父组件方法--同步数据给父组件
const clearSubFormStatus = getParentMetheds?.clearSubFormStatus || (() => {}); //清空子字段选中状态
const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式

const props = defineProps({
  element: {
    //数据
    type: Object,
    default: () => {
      return {};
    }
  },
  parentIndex: {
    //父级索引
    type: Number || String,
    default: 0
  },
  index: {
    //子集索引
    type: Number || String,
    default: 0
  },
  levelIndex: {
    //详情嵌套的索引
    type: Number || String,
    default: 0
  },
  formAttribute: {
    type: Object
  }
});

console.log('grayList', props.formAttribute);
const data = reactive({
  editFieldObj: {}, //当前被编辑的字段信息
  active: inject('sharedConfigData')?.active
});

const isSysLayout = computed(() => {
  return splitType?.value == 2;
});

const setConfig = async (callbackData) => {
  if (entityStore.entityGray || [2, 3].includes(splitType?.value)) {
    return;
  }
  clearSubFormStatus();
  data.editFieldObj = callbackData;

  sendModule(props.index, props.levelIndex, -1, { ...callbackData, ...{ parentFieldType: 27 } }, '', true);
};
const setClickStatus = () => {
  data.editFieldObj = {};
};
defineExpose({ setClickStatus });
</script>

<style scoped lang="less">
@import './detail-sub-form-table.less';
</style>
